import { LegacyParams, ParticipatedAdsResponse } from '@/types/supports'

import { offerwallApi } from '../axiosInstance'

export const fetchParticipatedAds = async (params: LegacyParams): Promise<ParticipatedAdsResponse> => {
  const { data } = await offerwallApi.get<LegacyParams, ParticipatedAdsResponse>('/help_requests/participated_ads', {
    params: params,
    headers: {}
  })

  return data
}
